import {
  SET_STUDENTS_DRIVE_LIST,
  SET_VIEW_DRIVE_INFO,
} from 'modules/DriveInfo/action'

const initialState = {
  studentDriveList: {},
  studentViewDriveInfo: [],
}

export default (state = initialState, action) => {
  switch (action.type) {
    case SET_STUDENTS_DRIVE_LIST:
      return {
        ...state,

        studentDriveList: action.data,
      }
    case SET_VIEW_DRIVE_INFO:
      return {
        ...state,
        studentViewDriveInfo: action.data,
      }
    default:
      return state
  }
}
